<form [formGroup]="sensor" (ngSubmit)="onSubmit()">
    <h2 mat-dialog-title>
        @if (isEdit) {
            {{ 'asset.edit_sensor' | transloco }}
        } @else {
            {{ 'asset.add_sensor' | transloco }}
        }
    </h2>
    <mat-dialog-content>

        <mat-form-field class="loren-form-field">
            <mat-label>{{ "asset.device_property" | transloco }}</mat-label>
            <input matInput
                   [formControl]="deviceControl"
                   [matAutocomplete]="deviceAuto"
                   [required]="!isEdit"/>
            <mat-autocomplete #deviceAuto="matAutocomplete"
                              [displayWith]="displayDevice"
                              [autoActiveFirstOption]="true">
                @for (device of devices$ | async; track device.id) {
                    <mat-option class="multiline-option" [value]="device">
                        <div>{{ device.deviceName }}</div>
                        <div class="imei">
                            <strong>IMEI:&nbsp;</strong>{{ device.imei }}
                        </div>
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="loren-form-field">
            <mat-label>{{ "asset.sensor" | transloco }}</mat-label>
            <input matInput
                   [formControl]="sensorControl"
                   [matAutocomplete]="sensorAuto"
                   [required]="!isEdit"/>
            <mat-autocomplete #sensorAuto="matAutocomplete"
                              [displayWith]="displaySensor"
                              [autoActiveFirstOption]="true">
                @for (item of sensors$ | async; track item.sensorId) {
                    <mat-option
                            class="multiline-option"
                            [value]="item"
                            [disabled]="item.disabled"
                    >
                        @if (item.device) {
                            <div class="sensor-list-title">
                                {{ item.device.deviceName }} &raquo; {{ item.translationKey | transloco }}
                            </div>
                        } @else {
                            <div>{{ "metering_type.sensor_for" | transloco }}&nbsp;{{ item.translationKey | transloco }}</div>
                        }
                        @if (item.mac) {
                            <div class="mac">
                                <strong>{{ "asset.mac_address" | transloco }}:</strong>
                                {{ item.mac }}
                            </div>
                        }
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        @if (sensor.controls.meteringContext) {
            <mat-form-field class="loren-form-field">
                <mat-label>{{ "asset.metering_context" | transloco }}</mat-label>
                <mat-select formControlName="meteringContext" required>
                    @for (meteringContext of meteringContexts; track meteringContext) {
                        <mat-option [value]="meteringContext">
                            {{ METERING_CONTEXT_TRANSLATION_NAMES.get(meteringContext) | transloco }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <mat-form-field class="loren-form-field">
            <mat-label>{{ "asset.sensor_description" | transloco }}</mat-label>
            <input matInput formControlName="description" required/>
            @if (sensor.controls.description.invalid) {
                <mat-error>{{ "errors.field_required" | transloco }}</mat-error>
            }
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{ 'operations.cancel' | transloco }}</button>
        <button mat-button type="submit" color='primary'>{{ 'operations.save' | transloco }}</button>
    </mat-dialog-actions>
</form>